import { cart } from 'wix-stores';


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button3_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
    
    let product;
    let product_id

     $w('#productPage1').getProduct()
  .then((product) => {
    let productName = product.name;
    let productDescription = product.description;
     let product_id = product._id
    // see example product object below
    
 // })
 // .catch((error) => {
 //   console.error(error);
 // });
 console.log('Product =' + product_id);
//$w('#shoppingCartIcon1').addToCart(productId, 1, {choices: selectedOptions});
 $w("#shoppingCartIcon1").addToCart(product_id,1) 
    .then(() => {
      console.log("Product added");
    })
    .catch((error) => {
      console.log(error);
    });
     })
  .catch((error) => {
    console.error(error);
  });
}
